import React from "react";
import { Line } from "react-chartjs-2";
import { getCommonOptions } from "./cardConfig";
import CustomLegends from "./CustomLegends";
import EllipsisWithTooltip from "react-ellipsis-with-tooltip";
import BootstrapTable from "react-bootstrap-table-next";
import {
  getPeriodDates,
  isDatasetsDataEmpty,
  isValidChartData,
} from "../../Data/options";
import NoSubscription from "../NoSubscription";
import moment from "moment";

const TableCard = ({
  data,
  chartTitle,
  formatType,
  metric,
  isDummyData,
  noSubscription,
  layoutItem,
  periodValue,
  showTimePeriod,
  DateRange,
  chartComparison,
}) => {
  const aspectRatio = layoutItem ? layoutItem?.w / layoutItem.cols : 1;

  let tableColumns = [
    {
      dataField: "",
      text: "EHID",
      headerClasses: "",
      formatter: (cell, row) => (
        <div className="ehid-column">
          <span>{row?.ehid}</span>
          <div className="ehid"><EllipsisWithTooltip placement="bottom">{row?.hotelName}</EllipsisWithTooltip></div>
        </div>
      ),
    },
    {
      dataField: "",
      text: "Actual",
      headerClasses: "",
      formatter: (cell, row) => (
        <div>
          <span>
            {chartTitle?.toString()?.includes("Occupancy")
              ? `${row?.actual}%`
              : `$${row?.actual}`}
          </span>
        </div>
      ),
    },
  ];
  const renderColumns = (): any[] => {
    if (chartComparison.findIndex((x) => x?.value == "Budget") >= 0) {
      tableColumns = [
        ...tableColumns,
        {
          dataField: "",
          text: "Budget",
          headerClasses: "",
          formatter: (cell, row) => (
            <div>
              <span>
                {chartTitle?.toString()?.includes("Occupancy")
                  ? `${row?.budget}%`
                  : `$${row?.budget}`}
              </span>
              <span
                className={`variance ${
                  +row?.budgetVariance >= 0 ? "green" : "red"
                }`}
              >
                {row?.budgetVariance}%
              </span>
            </div>
          ),
        },
      ];
    }

    if (chartComparison.findIndex((x) => x?.value == "Last Year") >= 0) {
      tableColumns = [
        ...tableColumns,

        {
          dataField: "",
          text: "Last Year",
          headerClasses: "",
          formatter: (cell, row) => (
            <div>
              <span>
                {chartTitle?.toString()?.includes("Occupancy")
                  ? `${row?.lastYearValue}%`
                  : `$${row?.lastYearValue}`}
              </span>
              <span
                className={`variance ${
                  +row?.lastYearVariance >= 0 ? "green" : "red"
                }`}
              >
                {row?.lastYearVariance}%
              </span>
            </div>
          ),
        },
      ];
    }

    if (chartComparison.findIndex((x) => x?.value == "Last 2 Year") >= 0) {
      tableColumns = [
        ...tableColumns,

        {
          dataField: "",
          text: "Last Two Years",
          headerClasses: "",
          formatter: (cell, row) => (
            <div>
              <span>
                {chartTitle?.toString()?.includes("Occupancy")
                  ? `${row?.lastTwoYearValue}%`
                  : `$${row?.lastTwoYearValue}`}
              </span>
              <span
                className={`variance ${
                  +row?.lastTwoYearVariance >= 0 ? "green" : "red"
                }`}
              >
                {row?.lastTwoYearVariance}%
              </span>
            </div>
          ),
        },
      ];
    }

    return tableColumns;
  };

  let FromDate, ToDate;
  if (showTimePeriod) {
    ({ FromDate, ToDate } = DateRange || {});
  }

  const PeriodType =
    periodValue == 5
      ? "YTD"
      : periodValue == 4
      ? "Trailing 12"
      : periodValue == 1
      ? "Current Period"
      : null;
  return (
    <div
      className={`line-chart-metric chart-metric table-card-metric ${
        aspectRatio < 0.4 ? "view-1-3" : ""
      }`}
      style={{ width: "100%", margin: "0 auto" }}
    >
      <h2 className="chart-heading" style={{ whiteSpace: "pre-wrap" }}>
        <div className="d-flex">
          <EllipsisWithTooltip placement="top">
            {chartTitle}{" "}
          </EllipsisWithTooltip>
          {showTimePeriod && (
            <div className="badge">
              <EllipsisWithTooltip placement="bottom">
                {`Showing ${PeriodType} ${FromDate} - ${ToDate}`}
              </EllipsisWithTooltip>
              <span>
                <svg
                  stroke="currentColor"
                  fill="currentColor"
                  stroke-width="0"
                  version="1.1"
                  viewBox="0 0 16 16"
                  height="1em"
                  width="1em"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M7 4.75c0-0.412 0.338-0.75 0.75-0.75h0.5c0.412 0 0.75 0.338 0.75 0.75v0.5c0 0.412-0.338 0.75-0.75 0.75h-0.5c-0.412 0-0.75-0.338-0.75-0.75v-0.5z"></path>
                  <path d="M10 12h-4v-1h1v-3h-1v-1h3v4h1z"></path>
                  <path d="M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM8 14.5c-3.59 0-6.5-2.91-6.5-6.5s2.91-6.5 6.5-6.5 6.5 2.91 6.5 6.5-2.91 6.5-6.5 6.5z"></path>
                </svg>
              </span>
            </div>
          )}
        </div>
      </h2>
      <>
        {noSubscription ? (
          <NoSubscription
            isNoHidsSelected={noSubscription == 2}
            subscription={metric?.moduleNames}
          />
        ) : (
          <>
            {data?.length > 0 && (
              <BootstrapTable
                keyField="itemUniqueNo"
                data={data || []}
                columns={renderColumns() || tableColumns}
              />
            )}
          </>
        )}
      </>
    </div>
  );
};

export default React.memo(TableCard);
